import BlackLayout from '@/layout/black-layout'

export default {
  path: '/print',
  component: BlackLayout,
  name: 'Print',
  meta: { title: '打印', role: 1522 },
  hidden: true,
  children: [
    {
      path: 'receipt',
      name: 'PrintReceipt',
      hidden: true,
      component: () => import('@/pages/fund_account/print-receipt'),
      meta: { title: '批量打印回单', role: 1524 }
    }
  ]
}
